import axios from "axios";

const requests = axios.create({
    baseURL: '/',
    timeout: 100000,
});
requests.interceptors.request.use((config) => {
    config.headers['accept-language']=localStorage.getItem("language")
    // config.headers['accept-language']="en"
    // config.headers['Content-Type']="application/json;charset=UTF-8"
    config.headers['Token']=localStorage.getItem("token") || getUrlParams2(location.href).token
    config.headers['X-DS']= config.headers.code ||  localStorage.getItem("X-DS")
    config.method = "post"
    //config是个配置对象，对象里面有一个属性很重要，headers请求头
    return config;
});

//响应拦截器：包含两个函数（一个是成功返回的函数，一个是失败的返回的函数）
requests.interceptors.response.use((res) => {
    //成功的回调函数：服务器响应数据回来以后，响应拦截器可以检测到，可以做一些事情。
    return res;
}, (error) => {
    if (error?.response?.status == 401){
        localStorage.setItem('token', "");
        localStorage.setItem('X-DS', "");
        // this.$toast.add({severity:'warn', summary: '登陆过期!请重新登录', detail:'',styleClass:'toastWarn', life: 3000});
        window.location.href="/"
    }
    return new Error('faile')
});
//对外暴露requests(axios的二次封装)
export default requests;
function getUrlParams2(url) {
	let urlStr = url.split('?')[1]
	const urlSearchParams = new URLSearchParams(urlStr)
	const result = Object.fromEntries(urlSearchParams.entries())
	return result
}